<template>
	<div style="background-color: #F7F7F7;padding: 15px 0;">
		<b-container style="padding: 0 !important;" class="bv-example-row">
			<b-breadcrumb style="background-color: #fff;" :items="items"></b-breadcrumb>
			<div class="box-one" style="background-color: #000000;">
				<div class="row">
					<div class="col-md-9 col-xs-12 video-left">
						<div ref="videoBox" class="video-box">
							<ali-player @waiting="waiting" :skinLayout="skinLayout" style="object-fit: fill;"
								:playsinline="true" class="ali-video" v-if="show" :encryptType="0" :vid="form.videoId"
								:playauth="form.playAuth" ref="player" :useFlashPrism="false" :autoplay="true"
								:isLive="false" :showBuffer="true" :cover="form.coverUrl" :showBarTime="true"
								:disableSeek="false" :isFast="form.allowFast" showBarTime="500" width="100%"
								controlBarVisibility="always">
							</ali-player>
						</div>
						<div
							style="padding:0 15px;font-size: 14px;height: 40px;display: flex;justify-content: space-between;align-items: flex-start;">
							<div style="flex-shrink: 0;">当前视频已观看进度：</div>
							<div style="width: 100%;margin: 0 10px;">
								<timeLine v-model="form.contentParse" :max="parseFloat(form.duration)"></timeLine>
							</div>
							<div style="flex-shrink: 0;">{{pp(form.percent)}}%</div>
						</div>
					</div>
					<div class="col-md-3 col-xs-12 video-right">
						<div class="list-area">
							<div style="color: #FFF;height: 50px;display: flex;align-items: center;margin-left: 15px;">
								<i class="el-icon-s-fold"></i>课程目录
							</div>
							<div class="lesson-area" style="height: 540px;overflow-y: scroll;">
								<div v-for="(item,index) in chapterInfo" :key="index">
									<div @click="changeLesson(item,index)"
										style="padding: 5px;cursor: pointer;border-bottom: 1px solid #000000;border-top: 2px solid #000000;">
										<div class="start_layout" style="padding: 5px"
											:style="lessonIndex==index?'color: #FFBC7B':''">
											<div>
												<i v-if="item.show" class="el-icon-caret-bottom"></i>
												<i v-else class="el-icon-caret-right"></i>
											</div>
											<div style="margin-left: 5px;">
												<div>{{item.title}}</div>
												<div style="font-size: 12px;">{{item.lecturer}}
												</div>
											</div>
										</div>
									</div>
									<div v-if="item.show"
										style="padding: 10px;cursor: pointer;font-size: 13px;margin-left: 10px;"
										@click.stop="changeVideo(item1,index1,index)"
										:style="lessonIndex==index&&playIndex==index1?'color:#409EFF;':''"
										v-for="(item1,index1) in item.videoList" :key="index1">
										<div class="between_layout">
											<div class="start_layout">
												<div style="flex-shrink: 0;"><i class="el-icon-video-play"></i>
												</div>
												<div>{{item1.title}}</div>
											</div>
											<div style="flex-shrink: 0;">{{timeFormat(item1.duration)}}</div>
										</div>
										<div class="between_layout" style="margin-top:6px;font-size: 12px;">
											<div>{{item1.points}}分</div>
											<div>
												<span>已观看：{{pp(item1.userVideo.percent)}}%</span>
											</div>
											<!-- <div>
												<span style="color: red;" v-if="item1.userVideo.percent==0">未观看</span>
												<span style="color: greenyellow;"
													v-else-if="item1.userVideo.percent==100">已看完</span>
												<span style="color: orange;" v-else>未看完</span>
											</div> -->
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div style="background-color: #fff;margin-top: 15px;padding: 15px;">
				<div class="between_layout">
					<div style="font-weight: 600;">{{userVideo.platformName}}<span
							style="color: red;margin-left: 10px;font-size: 13px;">(学习进度{{userVideo.percent}}%)</span>
					</div>
					<div style="margin-top: 6px;" class="links-box-right">
						<el-button class="btn1" @click="toExam(0)" size="mini" type="danger" round
							icon="el-icon-notebook-1">考试</el-button>
						<el-button class="btn1" @click="toExam(1)" size="mini" type="primary" round
							icon="el-icon-notebook-1">课后练习</el-button>
					</div>
				</div>
				<div style="font-size: 12px;color: #8d8d8d;margin: 10px 0;" class="start_layout">
					<div>
						<div>视频总时长：{{userVideo.totalTimeStr}}</div>
						<div style="margin-top: 8px;">初次观看时间：{{userVideo.firstTime}}</div>
					</div>
					<div style="margin-left: 30px;">
						<div>观看总时长：{{userVideo.viewTimeStr}}</div>
						<div style="margin-top: 8px;">最近观看时间：{{userVideo.lastTime}}</div>
					</div>
				</div>
			</div>
			<div class="hidden-xs" style="background-color: #fff;margin-top: 15px;padding: 15px;">
				<div class="lesson-menu">课程目录
				</div>
				<div style="box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;;padding: 15px;margin-bottom: 15px;"
					v-for="(item,index) in chapterInfo1" :key="index">
					<div class="between_layout">
						<div style="display: flex;align-items: flex-start;">
							<img style="margin-right: 10px;width: 16px;height: 16px;margin-top: 5px;"
								src="../../assets/images/book.png">
							<div>
								<div style="font-size: 16px;">{{item.name}}</div>
								<div style="color: #8d8d8d;margin-top: 5px;font-size: 14px;">{{item.lecturer}}</div>
								<div style="font-size: 12px;margin-top: 5px;">共<span
										style="color: red;">{{item.children.length}}</span>小节，已学习<span
										style="color: red;">{{item.percent}}%</span>，已获得积分数<span
										style="color: red;">{{item.points}}</span>
								</div>
							</div>
						</div>

						<el-button-group>
							<el-button @click="changeLesson1(item,index)" v-if="!item.show" size="mini"
								type="primary">展开<i class="el-icon-arrow-down"></i></el-button>
							<el-button @click="changeLesson1(item,index)" v-if="item.show" size="mini"
								type="primary">收起<i class="el-icon-arrow-up"></i></el-button>
						</el-button-group>
					</div>
					<div v-if="item.show" style="border-top: 1px solid #e7e7e7;margin-top: 15px;padding-top: 10px;">
						<div class="between_layout video-info" style="margin-bottom: 10px;"
							v-for="(item1,index1) in item.children" :key="index1">
							<div style="width: 100%;" class="between_layout">
								<div style="font-size: 14px;color: #000;">{{item1.name}}<span
										style="color: red;margin-left: 10px;font-size: 12px;">(已学{{item1.percent}}%)</span>
								</div>
								<div style="font-size: 14px;color: #ff6c00;">{{item1.points}}分</div>
								<div style="font-size: 14px;color: #8d8d8d;">{{timeFormat(item1.totalTime)}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-container>
	</div>
</template>

<script>
	import {
		chapterList,
		videoList,
		paperVerify,
		platformVideo,
		heartBeatInit,
		heartbeat,
		initLessonList
	} from "@/api/lesson";
	import {
		getInfo
	} from "@/api/login";
	import VueAliplayer from "@/components/AliPlayer";
	import timeLine from "@/components/timeLine";

	export default {
		components: {
			"ali-player": VueAliplayer,
			timeLine
		},
		filters: {
			fixed(val) {
				return val.toFixed(2)
			}
		},
		data() {
			return {
				chapterInfo: [],
				chapterInfo1: [],
				items: [{
					text: '首页',
					href: '/'
				}, {
					text: '课程目录',
					href: '#'
				}],
				lessonId: "",
				chapterId: "",
				form: {
					allowFast: false
				},
				currentLesson: {},
				show: false,
				playIndex: null,
				lessonIndex: null,
				timer: null,
				sendForm: {
					userId: undefined,
					videoId: undefined,
					startPoint: 0,
					endPoint: 0
				},
				userVideo: {},
				skinLayout: [{
						"name": "bigPlayButton",
						"align": "cc",
						"x": 30,
						"y": 80
					},
					{
						"name": "errorDisplay",
						"align": "tlabs",
						"x": 0,
						"y": 0
					},
					{
						"name": "infoDisplay"
					},
					{
						"name": "controlBar",
						"align": "blabs",
						"x": 0,
						"y": 0,
						"children": [{
								name: "progress",
								align: "blabs",
								x: 0,
								y: 44
							}, //播放进度条
							{
								name: "playButton",
								align: "tl",
								x: 15,
								y: 12
							}, //播放开始暂停按钮
							{
								name: "timeDisplay",
								align: "tl",
								x: 10,
								y: 7
							}, //播放视频时间
							{
								"name": "fullScreenButton", //全屏按钮
								"align": "tr",
								"x": 10,
								"y": 10
							},
							{
								"name": "volume", //音量
								"align": "tr",
								"x": 5,
								"y": 10
							}
						]
					}
				]
			}
		},
		created() {
			this.lessonId = this.$route.query.baseId
			this.getChapter()
			getInfo().then(res => {
				this.sendForm.userId = res.data.user.userId
			})
			initLessonList(this.$route.query.baseId).then(res => {
				this.userVideo = res.data.userVideo
				this.chapterInfo1 = res.data.userVideoDetails
				this.chapterInfo1.map(info => {
					info.show = false
				})
				this.$forceUpdate()
			})
		},
		beforeDestroy() { //页面关闭时清除定时器
			clearInterval(this.timer);
			this.$refs.player.pause()
		},
		methods: {
			waiting(e) {
				console.log('e: ', e);
			},
			pp(aa) {
				return Number(aa).toFixed(2)
			},
			getChapter() {
				chapterList(this.lessonId).then(res => {
					res.data.map(item => {
						item.show = false
						item.videoList = []
					})
					this.currentLesson = res.data[0]
					this.chapterId = res.data[0].baseId
					videoList(res.data[0].baseId).then(video => {
						res.data[0].show = true
						res.data[0].videoList = video.data
						this.$forceUpdate()
						this.changeVideo(video.data[0], 0, 0)
					})
					this.chapterInfo = res.data
					this.$forceUpdate()
				})
			},
			//切换课程
			changeLesson(item, sort) {
				this.chapterId = item.baseId
				this.chapterInfo.map((info, index) => {
					if (index == sort) {
						info.show = !info.show
						if (info.videoList.length == 0) {
							videoList(item.baseId).then(res => {
								info.videoList = res.data
								this.$forceUpdate()
							})
						}
						this.$forceUpdate()
					} else {
						info.show = false
						this.$forceUpdate()
					}
				})
			},
			//切换课程
			changeLesson1(item, sort) {
				this.chapterInfo1.map((info, index) => {
					if (index == sort) {
						info.show = !info.show
						this.$forceUpdate()
					}
				})
			},
			//切换视频
			changeVideo(item, index1, index) {
				this.getVideoInfo(item.baseId, item.userVideo)
				this.playIndex = index1
				this.lessonIndex = index
				this.currentLesson = this.chapterInfo[index]
			},
			//获取视频详情
			getVideoInfo(id, userVideo) {
				this.show = false
				platformVideo(id).then(res => {
					this.show = true
					this.form = res.data.videoVo
					if (this.form.allowFast) {
						this.skinLayout = [{
								"name": "bigPlayButton",
								"align": "cc",
								"x": 30,
								"y": 80
							},
							{
								"name": "errorDisplay",
								"align": "tlabs",
								"x": 0,
								"y": 0
							},
							{
								"name": "infoDisplay"
							},
							{
								"name": "controlBar",
								"align": "blabs",
								"x": 0,
								"y": 0,
								"children": [{
										name: "progress",
										align: "blabs",
										x: 0,
										y: 44
									}, //播放进度条
									{
										name: "playButton",
										align: "tl",
										x: 15,
										y: 12
									}, //播放开始暂停按钮
									{
										name: "timeDisplay",
										align: "tl",
										x: 10,
										y: 7
									}, //播放视频时间
									{
										"name": "fullScreenButton", //全屏按钮
										"align": "tr",
										"x": 10,
										"y": 10
									},
									{
										"name": "volume", //音量
										"align": "tr",
										"x": 5,
										"y": 10
									}
								]
							}
						]
					} else {
						this.skinLayout = [{
								"name": "bigPlayButton",
								"align": "cc",
								"x": 30,
								"y": 80
							},
							{
								"name": "errorDisplay",
								"align": "tlabs",
								"x": 0,
								"y": 0
							},
							{
								"name": "infoDisplay"
							},
							{
								"name": "controlBar",
								"align": "blabs",
								"x": 0,
								"y": 0,
								"children": [{
										name: "playButton",
										align: "tl",
										x: 15,
										y: 12
									}, //播放开始暂停按钮
									{
										name: "timeDisplay",
										align: "tl",
										x: 10,
										y: 7
									}, //播放视频时间
									{
										"name": "fullScreenButton", //全屏按钮
										"align": "tr",
										"x": 10,
										"y": 10
									},
									{
										"name": "volume", //音量
										"align": "tr",
										"x": 5,
										"y": 10
									}
								]
							}
						]
					}
					this.form.percent = userVideo.percent
					this.sendForm.videoId = this.form.videoId
					this.$forceUpdate()
					heartBeatInit({
						videoId: this.form.videoId,
						chapterId: this.chapterId,
						platformId: this.lessonId
					}).then(record => {
						if (record.data) {
							setTimeout(() => {
								this.$refs.player.seek(record.data.lastPosition)
								this.sendForm.startPoint = record.data.lastPosition
								clearInterval(this.timer);
								this.startCountDown()
							});
							this.form.contentParse = ''
							record.data.contentParse.forEach((item, index) => {
								this.form.contentParse = this.form.contentParse + (item
									.startPoint + '~' + item
									.endPoint + (index == record.data.contentParse.length - 1 ?
										'' : ';'))
							})
						} else {
							setTimeout(() => {
								this.sendForm.startPoint = 0
								clearInterval(this.timer);
								this.startCountDown()
							});
						}
					})
				})
			},
			getProgress() {
				heartBeatInit({
					videoId: this.form.videoId,
					chapterId: this.chapterId,
					platformId: this.lessonId
				}).then(record => {
					if (record.data) {
						this.form.contentParse = ''
						this.form.percent = record.data.percent
						record.data.contentParse.forEach((item, index) => {
							this.form.contentParse = this.form.contentParse + (item
								.startPoint + '~' + item
								.endPoint + (index == record.data.contentParse.length - 1 ?
									'' : ';'))
						})
						this.$forceUpdate()
					}
				})
			},
			startCountDown() {
				this.timer = setInterval(() => {
					this.sendForm.endPoint = this.$refs.player.getCurrentTime()
					var num = Math.abs(this.sendForm.startPoint - this.sendForm.endPoint)
					if (num > 0 && num < 6) {
						this.sendForm.platformId = this.lessonId
						this.sendForm.chapterId = this.chapterId
						heartbeat(this.sendForm)
						this.getProgress()
					}
					this.sendForm.startPoint = this.sendForm.endPoint
				}, 5000);
			},
			//秒转时分秒
			timeFormat(time) {
				const days = parseInt(time / 60 / 60 / 24)
				const hours = parseInt(time / 60 / 60 % 24)
				const minutes = parseInt(time / 60 % 60)
				const seconds = parseInt(time % 60)
				return `${!!days ? days + '天' : ''}${!!hours ? hours + ':' : ''}${!!minutes ? (minutes<10?'0'+minutes:minutes) + ':' : ''}${!!seconds ? (seconds<10?'0'+seconds:seconds): ''}`
			},
			//跳转考试
			toExam(index) {
				if (index == 0) {
					paperVerify(this.lessonId).then(res => {
						if (res.data) {
							this.$router.push({
								path: "/exam",
								query: {
									lessonId: this.lessonId,
									type: index
								}
							})
							this.$refs.player.pause()
						} else {
							this.$message({
								showClose: true,
								type: 'error',
								message: '未取得参加考试资格！！！'
							})
						}
					})
				} else {
					this.$router.push({
						path: "/exam",
						query: {
							lessonId: this.lessonId,
							type: index
						}
					})
					this.$refs.player.pause()
				}
			},
			//选择章节
			chooseChapter(count) {
				this.chapterInfo.map((item, index) => {
					if (index == count) {
						item.show = !item.show
					} else {
						item.show = false
					}
				})
				this.$forceUpdate()
			}
		}
	}
</script>

<style scoped lang="scss">
	.links-box-left {
		font-size: 17px;
		font-weight: 600;
		color: #051c35;
	}

	.list-area {
		width: 100%;
		background-color: #1b2128;
		height: 590px;
		color: #fff;
	}

	.lesson-area::-webkit-scrollbar {
		width: 0px;
		height: 10%
	}

	.lesson-area::-webkit-scrollbar-track {
		background-color: #f1f1f1;
		border-radius: 10px;
	}

	/* 滚动条的滑轨背景颜色 */
	.lesson-area::-webkit-scrollbar-thumb {
		background-color: #A4A9C1;
		border-radius: 10px;
	}

	.video-box {
		height: 560px;
		background-color: #000000;
	}

	.ali-video {
		height: 560px !important;
	}

	.video-left {
		padding-right: 0;
	}

	.video-right {
		padding-left: 0;
	}

	.lesson-menu {
		border-bottom: 1px solid #e7e7e7;
		padding-bottom: 10px;
		color: #409EFF;
		position: relative;
		margin-bottom: 15px;
	}

	.lesson-menu::after {
		content: '';
		position: absolute;
		bottom: -1px;
		left: 0;
		width: 70px;
		height: 2px;
		background-color: #409EFF;
	}

	.links-box-right {
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	@media screen and (max-width: 997px) {
		.links-box-right {
			display: flex;
			flex-direction: column;
			align-items: flex-end;

			.btn1 {
				width: 100%;
				margin-bottom: 10px;
			}
		}

		.video-box {
			height: 300px !important;
			margin-bottom: 15px;
		}

		.ali-video {
			height: 300px !important;
		}

		.video-left {
			padding-right: 15px !important;
			// padding-left: 15px !important;
			// box-sizing: border-box;
		}

		.video-right {
			// padding-right: 15px !important;
			padding-left: 15px !important;
			// box-sizing: border-box;
		}
	}

	.video-info {
		padding: 5px 20px;
	}

	.video-info:hover {
		background-color: #E7E7E7;
	}
</style>